export enum LogLevel {
  NONE = 0,
  ERROR = 1,
  INFO = 2,
  DEBUG = 3,
}

export interface VelatirResponse {
  requestId: string;
  state: 'approved' | 'denied' | 'pending';
}

export interface ClientConfig {
  apiKey?: string;
  baseUrl?: string;
  timeout?: number;
  logLevel?: LogLevel | number;
  maxRetries?: number;
  retryBackoff?: number;
}

export interface WatchOptions {
  pollingInterval?: number;
  maxAttempts?: number;
  metadata?: Record<string, unknown>;
}

export interface CreateWatchRequestPayload {
  functionname: string;
  args: Record<string, unknown>;
  doc?: string;
  metadata?: Record<string, unknown>;
}